'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactMotion = require('react-motion');

var _animation = require('@dekk/animation');

var _speakerNotes = require('@dekk/speaker-notes');

var _speakerNotes2 = _interopRequireDefault(_speakerNotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A single slide.
 * Renders a slide inside a `react-motion` wrapper.
 * Assigns css-variables to allow various transitions
 * @param {Object} props
 * @param {Boolean} props.isCurrent
 * @param {Boolean} props.isPrev
 * @param {Boolean} props.isNext
 * @param {Boolean} props.toPrev
 * @param {Boolean} props.fromPrev
 * @param {Boolean} props.toNext
 * @param {Boolean} props.fromNext
 * @param {Boolean} props.isPreview
 * @param {Boolean} props.present
 * @param {number} props.fragmentOrder
 * @param {String} props.className
 * @param {(ReactElement|ReactElement[])} props.children
 * @param {Object} props.springSettings
 * @param {number} props.springSettings.stiffness
 * @param {number} props.springSettings.damping
 * @param {number} props.springSettings.precision
 * @param {(Array|String)} props.animation
 * @param {(Array|String)} props.animationIn
 * @param {(Array|String)} props.animationOut
 * @param {(Array|String)} props.mixin
 * @param {String} props.background
 * @param {number} props.slideIndex
 */
var Slide = function (_Component) {
  _inherits(Slide, _Component);

  function Slide() {
    _classCallCheck(this, Slide);

    return _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).apply(this, arguments));
  }

  _createClass(Slide, [{
    key: 'getChildContext',


    /**
     * @private
     */
    value: function getChildContext() {
      return {
        isPreview: this.props.isPreview,
        fragmentHost: this.props.slideIndex,
        fragmentOrder: this.props.fragmentOrder || 0
      };
    }

    /**
     * Helper slots are filtered from the children.
     * These slots are allowed and will be ignored.
     * state setters, notes etc should be added here
     * @private
     */

  }, {
    key: 'getNotes',


    /**
     * Get notes from Items
     * @private
     */
    value: function getNotes(items) {
      return _react.Children.toArray(items).filter(function (child) {
        return child.type === _speakerNotes2.default;
      });
    }

    /**
     * @private
     * @param {(ReactElement|ReactElement[])} notes
     * @param {number} slideIndex
     */

  }, {
    key: 'setNotes',
    value: function setNotes(notes, slideIndex) {
      this.context.store.notes.splice(slideIndex, 1, notes);
    }

    /**
     * @private
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isCurrent) {
        this.setNotes(this.notes, this.props.slideIndex);
      }
    }

    /**
     * @private
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (this.props.isCurrent && oldProps.slideIndex !== this.props.slideIndex) {
        this.setNotes(this.getNotes(this.props.children), this.props.slideIndex);
      }
    }

    /**
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isPrev = _props.isPrev,
          isNext = _props.isNext,
          isCurrent = _props.isCurrent,
          onRest = _props.onRest;

      var direction = function () {
        if (_this2.props.fromPrev) {
          return -1;
        }
        if (_this2.props.fromNext) {
          return 1;
        }
        if (_this2.props.toPrev) {
          return -1;
        }
        if (_this2.props.toNext) {
          return 1;
        }
        if (isPrev) {
          return -1;
        }
        if (isNext) {
          return 1;
        }
        if (isCurrent) {
          return 0;
        }
        return -1;
      }();

      // Switch spring direction
      var springStyle = {
        time: (0, _reactMotion.spring)(isPrev || isNext ? 1 : 0, _extends({}, this.props.springSettings))
      };
      var handleRest = function handleRest() {
        if (typeof onRest === 'function' && isCurrent) {
          onRest(_this2.props.slideIndex);
        }
      };
      return _react2.default.createElement(
        _reactMotion.Motion,
        { style: springStyle, onRest: handleRest },
        function (_ref) {
          var time = _ref.time;

          var style = {
            '--time': time
          };
          return _react2.default.createElement(
            StyledSlide,
            {
              className: _this2.props.className,
              style: style,
              direction: direction,
              present: _this2.props.present,
              background: _this2.props.background,
              mixin: _this2.props.mixin,
              animation: _this2.props.animation,
              animationIn: _this2.props.animationIn,
              animationOut: _this2.props.animationOut },
            _this2.content
          );
        }
      );
    }
  }, {
    key: 'helperSlots',
    get: function get() {
      return [_speakerNotes2.default];
    }

    /**
     * Filtered children of the component.
     * Excludes helperSlots
     * @private
     */

  }, {
    key: 'content',
    get: function get() {
      var _this3 = this;

      return _react.Children.toArray(this.props.children).filter(function (child) {
        return !_this3.helperSlots.includes(child.type);
      });
    }

    /**
     * Filtered notes of the slide.
     * @private
     */

  }, {
    key: 'notes',
    get: function get() {
      return this.getNotes(this.props.children);
    }
  }], [{
    key: 'childContextTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        isPreview: _propTypes2.default.bool,
        fragmentOrder: _propTypes2.default.number,
        fragmentHost: _propTypes2.default.number
      };
    }

    /**
     * @private
     */

  }, {
    key: 'propTypes',
    get: function get() {
      return {
        isCurrent: _propTypes2.default.bool,
        isPrev: _propTypes2.default.bool,
        isNext: _propTypes2.default.bool,
        toPrev: _propTypes2.default.bool,
        fromPrev: _propTypes2.default.bool,
        toNext: _propTypes2.default.bool,
        fromNext: _propTypes2.default.bool,
        isPreview: _propTypes2.default.bool,
        present: _propTypes2.default.bool,
        fragmentOrder: _propTypes2.default.number,
        className: _propTypes2.default.string,
        onRest: _propTypes2.default.func,
        children: _propTypes2.default.node.isRequired,
        springSettings: _propTypes2.default.shape({
          stiffness: _propTypes2.default.number,
          damping: _propTypes2.default.number,
          precision: _propTypes2.default.number
        }),
        animation: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        animationIn: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        animationOut: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        background: _propTypes2.default.string,
        slideIndex: _propTypes2.default.number
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        isCurrent: false,
        isPrev: false,
        isNext: false,
        toPrev: false,
        fromPrev: false,
        toNext: false,
        fromNext: false,
        isPreview: false,
        present: false,
        onRest: function onRest() {
          return null;
        },
        fragmentOrder: 0,
        className: undefined,
        springSettings: undefined,
        animation: undefined,
        animationIn: undefined,
        animationOut: undefined,
        mixin: undefined,
        background: undefined,
        slideIndex: -1
      };
    }

    /**
     * Get contextTypes
     * @private
     *
     * @return {{store: store, fragmentHost: number, hostedFragmentOrder: number}}
     */

  }, {
    key: 'contextTypes',
    get: function get() {
      return {
        store: _propTypes2.default.object.isRequired
      };
    }
  }]);

  return Slide;
}(_react.Component);

/**
 * @private
 */


var SlideDirection = _styledComponents2.default.div.withConfig({
  displayName: 'src__SlideDirection'
})(['--direction:', ';z-index:', ';'], function (_ref2) {
  var direction = _ref2.direction;
  return direction;
}, function (_ref3) {
  var isCurrent = _ref3.isCurrent;
  return isCurrent ? 1 : 0;
});

/**
 * @private
 */
var switchAnimation = function switchAnimation(props) {
  if (props.direction === 1 && props.animationIn) {
    return props.animationIn;
  }
  if (props.direction === -1 && props.animationOut) {
    return props.animationOut;
  }
  return props.animation || _animation.slide.normal;
};

/**
 * @private
 */
var StyledSlide = (0, _styledComponents2.default)(SlideDirection).withConfig({
  displayName: 'src__StyledSlide'
})(['', ';position:absolute;top:0;left:0;overflow:hidden;background:', ';background-size:cover;color:var(--slide-color,currentColor);', ';'], function (_ref4) {
  var mixin = _ref4.mixin;
  return mixin || '';
}, function (_ref5) {
  var background = _ref5.background;
  return background || 'var(--slide-background, none)';
}, function (props) {
  return props.present ? '\n      transform: scale3d(var(--scale), var(--scale), 1);\n      transform-origin: 0 0;\n      width: calc(100% / var(--scale));\n      height: calc(100% / var(--scale));\n      right: auto;\n      bottom: auto;\n    ' : '\n      right: 0;\n      bottom: 0;\n      ' + switchAnimation(props) + ';\n    ';
});

exports.default = Slide;